<template>
  <div ref="rootEl" class="vem-embedded"></div>
</template>

<script>
// Entrada EMBEBIDA en SherpaCRM (Configuración › Materializaciones). Monta una sub-app aislada y le
// pasa la conexión por override en memoria: token tal cual lo guarda SherpaCRM («bearer …»),
// URL de servicios e idioma de la sesión.
import { createApp, defineComponent, h, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import App from './App.vue';
import { locale, normalizeLang } from './i18n.js';
import { clearRuntimeOverride, setRuntimeOverride } from './config/runtimeConfig.js';
import { resetCatalog } from './catalog.js';
import './styles/main.css';

export default defineComponent({
  name: 'VueEntityMaterializerEmbedded',
  props: {
    token: { type: String, default: '' },
    lang: { type: String, default: 'es' },
    apiBaseUrl: { type: String, default: '' },
  },
  setup(props) {
    const rootEl = ref(null);
    let subApp = null;

    const apply = () => {
      setRuntimeOverride({ token: props.token, baseUrl: props.apiBaseUrl, rawToken: true, lang: props.lang, embedded: true });
      locale.value = normalizeLang(props.lang);
    };

    apply();

    onMounted(() => {
      resetCatalog();
      subApp = createApp({ render: () => h(App, { embedded: true }) });
      subApp.mount(rootEl.value);
    });

    watch(() => [props.token, props.apiBaseUrl, props.lang], apply);

    onBeforeUnmount(() => {
      if (subApp) {
        subApp.unmount();
        subApp = null;
      }
      clearRuntimeOverride();
    });

    return { rootEl };
  },
});
</script>

<style scoped>
.vem-embedded {
  height: 100%;
  min-height: 600px;
  overflow: auto;
}
</style>
